var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container top-level-div"},[_c('button',{staticClass:"mylisting-button dark-button",on:{"click":function($event){return _vm.createContent()}}},[_vm._v("Create Content")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1b032b01","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/general/CreateContent.vue
// module id = 811
// module chunks = 0